import { Location } from "app/location/location.model";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
import { LocationGroupMapper } from "./location-group.mapper";
export class LocationGroup extends CrudAbstractModel {
  constructor(
    public id: number,
    public name: string,
    public availableOnline?: string,
    public locations: Location[] = [],
    public countries: string[] = [],
    public kind?: string,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public setId(id) {
    this.id = id;
  }

  public isValid(): boolean {
    return true;
  }

  public getLocations(): Location[] {
    return this.locations;
  }

  public getClone(): LocationGroup {
    return LocationGroupMapper.map({
      id: this.id,
      ...this.getRequestParams(),
    });
  }

  public getRequestParams() {
    return {
      name: this.name,
      availableOnline: this.availableOnline,
      locations: this.locations
        ? this.locations.map((location) => location.getId())
        : [],
      countries: this.countries,
    };
  }

  public get locationNames() {
    let output = "";
    for (let i = 0; i < this.locations?.length; i++) {
      output += `${this.locations[i].getName()} (${this.locations[i].getKind()})`;
      if (i < this.locations.length - 1) {
        output += "\n";
      }
    }

    return output;
  }
}
